import type { ICraft } from "@framework/types";
import { cleanUpAsset } from "@framework/exchange";

export const craftFilter = ({ item, price, craftStatus }: ICraft) => ({
  item: cleanUpAsset(item) as any,
  price: cleanUpAsset(price) as any,
  craftStatus,
});

export const prepareCraftInitialValues = ({ id, item, price, craftStatus }: Partial<ICraft>) => {
  return {
    craftStatus,
    id,
    item,
    price,
  };
};
